<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <el-button type="primary" size="small" @click="add"
        >新建抽奖活动</el-button
      >
      <div>
        <el-input
          clearable
          style="width:250px"
          v-model.trim="searchCondition.drawName"
          placeholder="请输入抽奖活动名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchCondition.applyDate"
          type="datetimerange"
          range-separator="至"
          start-placeholder="选择创建时间段"
          end-placeholder="选择创建时间段"
        ></el-date-picker>

        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="list"
        style="width: 100%"
        ref="table"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="活动名称"
          prop="drawName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="创建时间"
          prop="createTime"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="抽奖时间"
          prop="drawTime"
        >
          <template slot-scope="scope">
            {{ scope.row.drawStartTime }}至{{ scope.row.drawEndTime }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          label="抽奖档位"
          prop="gearsNum"
        >
          <template slot-scope="scope">
            {{ scope.row.gearsNum }}档
          </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          label="订单匹配时段"
          prop="matchOrderMode"
        >
          <template slot-scope="scope">
            {{
              scope.row.matchOrderMode === "range"
                ? scope.row.matchOrderStartTime +
                  "至" +
                  scope.row.matchOrderEndTime
                : "当日兑换"
            }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="已兑抽奖券人数"
          prop="exchangeNum"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="已抽奖人数"
          prop="drawNum"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="抽奖活动状态"
          prop="idcardName"
          ><template slot-scope="scope">
            <div v-if="scope.row.enabledState === 'yes'" class="success">
              上线
            </div>
            <div v-if="scope.row.enabledState === 'no'" class="danger">
              下线
            </div>
            <div v-if="scope.row.enabledState === 'notStart'" class="gray">
              未开始
            </div>
            <div v-if="scope.row.enabledState === 'end'" class="blue">
              过期
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderSn"
          label="操作"
          width="250"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                class="success"
                v-if="scope.row.enabledState === 'no'"
                @click="operation(scope.row)"
                >上线</el-button
              >
              <el-button
                size="small"
                type="text"
                v-if="scope.row.enabledState === 'yes'"
                @click="operation(scope.row)"
                >下线</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="detail(scope.row, 'detail')"
                >详情</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="detail(scope.row, 'copy')"
                >复制</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="productQrcode(scope.row)"
                >活动二维码</el-button
              >
            </div>
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                v-if="scope.row.enabledState === 'notStart'"
                @click="detail(scope.row, 'edit')"
                >编辑</el-button
              >
              <el-button
                size="small"
                type="text"
                v-if="scope.row.enabledState === 'notStart'"
                @click="del(scope.row)"
                >删除</el-button
              >

              <el-button size="small" type="text" @click="water(scope.row)"
                >抽奖流水</el-button
              >
              <el-button
                v-if="scope.row.drawMode !== 'offline'"
                size="small"
                type="text"
                @click="setDrawBigger(scope.row)"
                >后台抽奖页面</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="row.drawName"
      width="1300px"
      :visible.sync="dialogVisible"
    >
      <div slot="title" style="fontSize:16px;fontWeight:500">
        {{ row.drawName }}
        <span class="ml10">
          {{ row.drawStartTime }}至{{ row.drawEndTime }}
        </span>
      </div>
      <div>
        <div class="table-panel flex flex-start">
          <el-radio-group
            v-model="searchConditionDetails.timeStatus"
            size="small"
            @change="switchTab"
          >
            <el-radio-button label="alla">抽奖记录 </el-radio-button>
            <el-radio-button label="all">兑换记录 </el-radio-button>
          </el-radio-group>
        </div>
        <div class="table-panel flex flex-end">
          <el-select
            v-if="searchConditionDetails.timeStatus === 'alla'"
            filterable
            class="mr10"
            size="small"
            v-model="searchConditionDetails.prizeName"
            value-key="id"
            placeholder="请选择奖品名"
          >
            <el-option
              :label="item.value"
              :value="item.value"
              v-for="(item, index) in groupArr"
              :key="index"
            ></el-option>
          </el-select>
          <!-- <el-autocomplete
            v-model="searchConditionDetails.state"
            :fetch-suggestions="querySearchAsync"
            @focus="groupListMe"
            placeholder="请输入内容"
            @select="handleSelect"
            size="small"
            clearable
          ></el-autocomplete> -->
          <el-input
            clearable
            style="width:300px"
            v-model.trim="searchConditionDetails.queryValue"
            :placeholder="placeholder"
            size="small"
            class="ipt mr10"
          >
            <el-select
              slot="prepend"
              size="small"
              style="width:100px"
              @change="selectQueryType"
              v-model="searchConditionDetails.queryType"
            >
              <el-option label="手机号" value="memberMobile"></el-option>
              <el-option label="会员名称" value="memberName"></el-option>
              <el-option
                label="订单号"
                value="receiptSn"
                v-if="searchConditionDetails.timeStatus === 'all'"
              ></el-option>
            </el-select>
          </el-input>

          <!-- <el-select
            size="small"
            clearable
            class="mr10"
            placeholder="请选择抽奖档位"
            v-model="searchConditionDetails.limitAmount"
            filterable
          >
            <el-option
              :label="v"
              :value="v"
              v-for="(v, i) in drawGearList"
              :key="i"
            >
            </el-option>
          </el-select> -->
          <!-- <el-select
            size="small"
            clearable
            class="mr10"
            placeholder="请选择奖券状态"
            v-model="searchConditionDetails.usedState"
            filterable
          >
            <el-option label="待使用" value="notUsed"> </el-option>
            <el-option label="已核销" value="used"> </el-option>
            <el-option label="已过期" value="overdue"> </el-option>
          </el-select> -->
          <el-date-picker
            :default-time="['00:00:00', '23:59:59']"
            class="mr10"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="searchConditionDetails.applyDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="选择核销时间段"
            end-placeholder="选择核销时间段"
          ></el-date-picker>
          <el-button type="primary" size="small" @click="searchDetail"
            >查询</el-button
          >
          <el-button
            type="success"
            size="small"
            @click="output"
            :loading="isOutputing"
            >导出</el-button
          >
        </div>
        <div class="table">
          <el-table
            v-if="searchConditionDetails.timeStatus === 'alla'"
            :data="detailsList"
            style="width: 100%"
            ref="tixian"
            stripe
            border
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="
                index => index + (currentPageDetail - 1) * pageSizeDetail + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="抽奖方式"
              prop="drawType"
            >
              <template slot-scope="scope">
                {{ scope.row.drawType === "hexiao" ? "线上核销" : "线上抽奖" }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="会员名称/电话"
              prop="memberInfo"
              width="150"
            >
              <template slot-scope="scope">
                {{ scope.row.memberName }}/{{ scope.row.memberMobile }}
              </template>
            </el-table-column>

            <el-table-column
              header-align="center"
              align="center"
              label="抽奖时间"
              prop="drawTime"
            >
              <template slot-scope="scope">
                {{ scope.row.drawTime }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="奖项"
              prop="prizeLevel"
            >
              <template slot-scope="scope">
                {{ scope.row.prizeLevel }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="获得奖品"
              prop="prizeName"
            >
              <template slot-scope="scope">
                {{ scope.row.prizeName }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="奖品数量"
              prop="prizeNum"
            >
              <template slot-scope="scope">
                {{ scope.row.prizeNum }}
              </template>
            </el-table-column>
            <!-- <el-table-column
              header-align="center"
              align="center"
              label="使用情况"
              prop="usedState"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.usedState === 'overdue'" class="gray">
                  已过期
                </div>
                <div v-if="scope.row.usedState === 'notUsed'" class="blue">
                  待使用
                </div>
                <div v-if="scope.row.usedState === 'used'" class="success">
                  已核销
                </div>
              </template>
            </el-table-column> -->

            <!-- <el-table-column
              header-align="center"
              align="center"
              label="兑换时间"
              prop="exchangeTime"
              width="150"
            >
            </el-table-column> -->
            <!-- <el-table-column
              header-align="center"
              align="center"
              label="活动时间"
              prop="declareTime"
            >
            </el-table-column> -->

            <el-table-column
              header-align="center"
              align="center"
              prop="verifyOperator"
              label="核销人"
            >
              <template slot-scope="scope">
                {{ scope.row.verifyOperator }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="verifyTime"
              label="核销时间"
            >
              <template slot-scope="scope">
                {{ scope.row.verifyTime }}
              </template>
            </el-table-column>
          </el-table>
          <el-table
            v-else
            :data="detailsList"
            style="width: 100%"
            ref="tixian"
            stripe
            border
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="
                index => index + (currentPageDetail - 1) * pageSizeDetail + 1
              "
            ></el-table-column>

            <el-table-column
              header-align="center"
              align="center"
              label="会员名称/电话"
              prop="memberInfo"
              width="150"
            >
              <template slot-scope="scope">
                {{ scope.row.memberName }}/{{ scope.row.memberMobile }}
              </template>
            </el-table-column>

            <el-table-column
              header-align="center"
              align="center"
              label="兑换时间"
              prop="exchangeTime"
            >
              <template slot-scope="scope">
                {{ scope.row.exchangeTime }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="兑换奖券数"
              prop="exchangeTicketNum"
              width="100"
            >
              <template slot-scope="scope">
                {{ scope.row.exchangeTicketNum }}
              </template>
            </el-table-column>

            <el-table-column
              header-align="center"
              align="center"
              prop="orderSns"
              label="兑换订单"
            >
              <template slot-scope="scope">
                {{ scope.row.orderSns }}
              </template>
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="totalDetail"
              @current-change="pagingDetail"
              @size-change="handleSizeChangeDetail"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPageDetail"
            ></el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="订单详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleOffline"
      width="600px"
    >
      <el-scrollbar :vertical="false" wrap-style="height: 300px;">
        <!-- <div class="mb20">
          会员：{{ currentRow.memberName }} 消费：<span class="primary"
            >￥{{ currentRow.totPrice }}</span
          >
        </div> -->
        <div class="dialog-body">
          <div class="mb20">
            <div class="table-panel title">商品信息</div>
            <div class="table">
              <el-table
                stripe
                border
                :data="orderDetailList"
                style="width: 100%"
                id="table"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  prop="spu_name"
                  align="center"
                  label="商品名"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="市场价"
                >
                  <template slot-scope="scope">
                    <span class="primary">￥{{ scope.row.market_price }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="门店价"
                >
                  <template slot-scope="scope">
                    <span class="primary">￥{{ scope.row.shop_price }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  prop="goods_number"
                  align="center"
                  label="商品数量"
                ></el-table-column>
              </el-table>
            </div>
          </div>
          <!-- <div v-if="couponInfo.length">
            <div class="table-panel title">购买后已发放优惠券</div>
            <div class="table">
              <el-table
                stripe
                border
                :data="couponInfo"
                style="width: 100%"
                id="table"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  prop="name"
                  align="center"
                  label="优惠券名"
                />
                <el-table-column
                  header-align="center"
                  prop="sendName"
                  align="center"
                  label="发放规则名"
                />
                <el-table-column
                  header-align="center"
                  prop="toOrder"
                  align="center"
                  label="已使用订单号"
                />
                <el-table-column
                  header-align="center"
                  prop="couponCode"
                  align="center"
                  label="优惠券码"
                />
                <el-table-column
                  header-align="center"
                  align="center"
                  label="优惠券状态"
                >
                  <template slot-scope="scope">
                    <span class="primary" v-if="scope.row.couponStatus === 2"
                      >已使用</span
                    >
                    <span class="primary" v-if="scope.row.couponStatus === 4"
                      >未使用</span
                    >
                    <span class="primary" v-if="scope.row.couponStatus === 5"
                      >冻结</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div> -->
        </div>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer flex flex-center">
        <!-- <el-button @click="sendCoupon(currentRow)" size="small" type="primary"
          >发券</el-button
        > -->
        <el-button @click="dialogVisibleOffline = false" size="small"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <hm-details-order
      :visible="dialogOrderDetails"
      @close="dialogOrderDetails = false"
      :orderId="orderId"
    >
    </hm-details-order>
    <el-dialog
      title="设置后台抽奖页面"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleBigger"
      width="1200px"
      @close="occlude"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="120px"
      >
        <!-- <el-form-item label="背景图" prop="gameBgp">
          <div v-if="ruleForm.gameBgp" class="flex">
            <div class="mr10 flex item-end priview">
              <el-image
                class="img"
                :src="ruleForm.gameBgp"
                alt="logo"
                :preview-src-list="[ruleForm.gameBgp]"
              />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemove('gameBgp')"
                  >删除</el-button
                >
              </div>
            </div>
            <div class="el-upload__tip">
              <span class="mr">
                上传图片注意：
                <br />1.图片格式：png、jpg、bmp
              </span>
            </div>
          </div>
          <el-upload
            v-else
            class="upload flex"
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :onSuccess="cropUploadSuccess"
            :beforeUpload="beforeUpload"
            :onProgress="uploading"
            :show-file-list="uploadShow"
          >
            <div class="flex upload-upload-btn">
              <div class="btn flex flex-column flex-center open-file">
                <div class="add-wrapper">
                  <span
                    class="hmicon icon-hao pointer"
                    style="margin-right: 0px"
                  ></span>
                </div>
                <span class="gray">上传首页浮动图</span>
              </div>
            </div>

            <div class="el-upload__tip" slot="tip">
              <span class="mr">
                上传图片注意：
                <br />2.图片格式：png、jpg、bmp
              </span>
            </div>
          </el-upload>
        </el-form-item> -->
        <el-form-item label="背景音乐链接" prop="gameBgm">
          <div class="flex item-center">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model="ruleForm.gameBgm"
              placeholder="请输入音乐链接/音乐网络地址"
            ></el-input>

            <i
              v-if="ruleForm.gameBgm"
              @click="startPlay('audio')"
              style="font-size:25px"
              class="el-icon-video-play"
            ></i>

            <i
              v-if="ruleForm.gameBgm"
              @click="pausePlay('audio')"
              style="font-size:25px"
              class="el-icon-video-pause ml10"
            ></i>

            <audio
              v-if="ruleForm.gameBgm"
              id="audio"
              ref="audio"
              :src="ruleForm.gameBgm"
              preload
            >
              对不起，您的浏览器不支持HTML5音频播放。
            </audio>
          </div>
        </el-form-item>
        <el-form-item label="中奖音乐" prop="winningBgm">
          <div class="flex item-center">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model="ruleForm.winningBgm"
              placeholder="请输入音乐链接/音乐网络地址"
            ></el-input>
            <i
              v-if="ruleForm.winningBgm"
              @click="startPlay('audio1')"
              style="font-size:25px"
              class="el-icon-video-play"
            ></i>

            <i
              v-if="ruleForm.winningBgm"
              @click="pausePlay('audio1')"
              style="font-size:25px"
              class="el-icon-video-pause ml10"
            ></i>

            <audio
              v-if="ruleForm.winningBgm"
              id="audio1"
              ref="audio1"
              :src="ruleForm.winningBgm"
              preload
            >
              对不起，您的浏览器不支持HTML5音频播放。
            </audio>
          </div>
        </el-form-item>
        <el-form-item label="网页显示" prop="showType">
          <el-radio-group v-model="ruleForm.showType" size="small">
            <el-radio label="popup">上下滑动型</el-radio>
            <el-radio label="text">左右轮转型</el-radio>
          </el-radio-group>
          <div class="flex">
            <div style="width:500px">
              <el-image
                v-if="ruleForm.showType === 'popup'"
                class="img"
                :src="gridbgp"
                alt="logo"
                :preview-src-list="[gridbgp]"
              />
              <el-image
                v-else
                class="img"
                :src="rollbgp"
                alt="logo"
                :preview-src-list="[rollbgp]"
              />
            </div>
            <!-- <div>
              选择需要显示的内容：
              <div class="form-item-tip">
                每项至少勾选一个
              </div>
              <div class="flex">
                <div>
                  中奖记录：
                </div>
                <el-form-item prop="showRecord" style="margin-bottom:30px">
                  <div>
                    <div>
                      <el-checkbox
                        v-model="ruleForm.winningRecordPhoneStatus"
                        true-label="yes"
                        false-label="no"
                        >电话号码(中间四位*号显示)</el-checkbox
                      >
                    </div>
                    <div>
                      <el-checkbox
                        v-model="ruleForm.winningRecordNameStatus"
                        true-label="yes"
                        false-label="no"
                        >姓名</el-checkbox
                      >
                    </div>
                    <div>
                      <el-checkbox
                        v-model="ruleForm.winningRecordImageStatus"
                        true-label="yes"
                        false-label="no"
                        >头像</el-checkbox
                      >
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div class="flex">
                <div>
                  中奖效果：
                </div>
                <el-form-item prop="showEffect">
                  <div>
                    <div>
                      <el-checkbox
                        v-model="ruleForm.winningEffectPhoneStatus"
                        true-label="yes"
                        false-label="no"
                        >电话号码(中间四位*号显示)</el-checkbox
                      >
                    </div>
                    <div>
                      <el-checkbox
                        v-model="ruleForm.winningEffectNameStatus"
                        true-label="yes"
                        false-label="no"
                        >姓名</el-checkbox
                      >
                    </div>
                    <div>
                      <el-checkbox
                        v-model="ruleForm.winningEffectImageStatus"
                        true-label="yes"
                        false-label="no"
                        >头像</el-checkbox
                      >
                    </div>
                  </div>
                </el-form-item>
              </div>
            </div> -->
          </div>
        </el-form-item>
        <el-form-item v-if="showView">
          <el-button type="text" @click="to" size="small"
            >生成网页链接</el-button
          >
        </el-form-item>
        <!-- <el-form-item label="" prop="enabledState">
          <el-switch
            style="display: block"
            v-model="ruleForm.enabledState"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="开启"
            inactive-text="关闭"
          >
          </el-switch>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer flex flex-center">
        <el-button type="primary" @click="save('ruleForm')" size="small"
          >保 存</el-button
        >
        <el-button @click="occlude" size="small">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="请用微信扫一扫"
      :visible.sync="qrcodeDialogVisible"
      :modal="false"
      width="250px"
    >
      <div class="qrcode-wrapper">
        <img style="width:100%" :src="activityCode" alt="二维码" />
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import myUpload from "vue-image-crop-upload";
import { getLoginUser } from "@/utils/auth";
import HmDetailsOrder from "@/components/HmDetailsOrder";
export default {
  components: {
    HmDetailsOrder,
    myUpload
  },
  data() {
    const showRecordValue = (rule, val, callback) => {
      if (
        this.ruleForm.winningRecordPhoneStatus === "no" &&
        this.ruleForm.winningRecordNameStatus === "no" &&
        this.ruleForm.winningRecordImageStatus === "no"
      ) {
        return callback(new Error("请至少勾选意一项"));
      }
      callback();
    };
    const showEffectValue = (rule, val, callback) => {
      if (
        this.ruleForm.winningEffectPhoneStatus === "no" &&
        this.ruleForm.winningEffectNameStatus === "no" &&
        this.ruleForm.winningEffectImageStatus === "no"
      ) {
        return callback(new Error("请至少勾选意一项"));
      }
      callback();
    };
    return {
      showView: false,
      gridbgp: "https://imgcdn.hemiao100.com/ThemePictures/aaaaaaaaaaa.png",
      rollbgp: "https://imgcdn.hemiao100.com/ThemePictures/bbbbbbbbbbb.png",
      showgameBgp: false,
      ruleForm: {
        gameBgp: "https://imgcdn.hemiao100.com/ThemePictures/drawBiggerBgp.png",
        gameBgm: "https://imgcdn.hemiao100.com/ThemePictures/gameBgm.mp3",
        winningBgm: "https://imgcdn.hemiao100.com/ThemePictures/winningBgm.mp3",
        showType: "popup",
        winningRecordPhoneStatus: "yes",
        winningRecordNameStatus: "yes",
        winningRecordImageStatus: "yes",
        winningEffectPhoneStatus: "yes",
        winningEffectNameStatus: "yes",
        winningEffectImageStatus: "yes",
        enabledState: "yes"
      },
      rules: {
        gameBgp: [{ required: true, message: "请选择背景图", trigger: "blur" }],
        showType: [
          { required: true, message: "请选择背景图", trigger: "blur" }
        ],
        showRecord: [{ validator: showRecordValue, trigger: "blur" }],
        showEffect: [
          {
            validator: showEffectValue,
            trigger: "blur"
          }
        ]
      },
      dialogVisibleBigger: false,
      orderDetailList: [],
      dialogVisibleOffline: false,
      dialogVisible: false,
      orderId: "",
      dialogOrderDetails: false,
      searchCondition: {},
      searchConditionDetails: {
        timeStatus: "alla",
        queryType: "memberMobile",
        queryValue: ""
      },
      placeholder: "请输入手机号",
      list: [],
      detailsList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      currentPageDetail: 1,
      pageSizeDetail: 10,
      totalDetail: 0,
      isOutputing: false,
      row: {},
      drawGearList: [],
      groupArr: [],
      uploadShow: true,
      activityCode: "",
      qrcodeDialogVisible: false
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async productQrcode() {
      let path = "lottery/myLottery";
      const { storeCode } = getLoginUser();
      const { result } = await this.$store.dispatch("createCouponQrcode", {
        path,
        storeCode
      });
      this.qrcodeDialogVisible = true;
      this.activityCode = result;
    },
    occlude() {
      this.dialogVisibleBigger = false;
      this.resetForm();
    },
    to() {
      this.$router.push({
        name: "DrawBigger",
        query: {
          ruleId: this.row.id
        }
      });
    },
    // 移除上传文件
    handleRemove(spreadBgp) {
      this.ruleForm[spreadBgp] = "";
    },
    // 正在上传
    uploading() {
      this.uploadShow = true;
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 1M!",
      //     type: "warning"
      //   });
      // }
      return extension || extension2 || extension3 || extension4;
    },
    resetForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
        this.ruleForm.id = "";
      }, 0);
    },
    // 开始播放
    startPlay(ref) {
      this.$refs[ref].play();
    },
    // 暂停
    pausePlay(ref) {
      this.$refs[ref].pause();
    },
    toggleShowgameBgp() {
      this.showgameBgp = !this.showgameBgp;
    },
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.gameBgp = jsonData.result;
        this.uploadShow = false;
      }
    },
    cropSuccess() {},
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.ruleId = this.row.id;
          params.gameBgp =
            params.showType === "popup"
              ? "https://imgcdn.hemiao100.com/ThemePictures/drawBiggerBgp.png"
              : "https://imgcdn.hemiao100.com/ThemePictures/rollbgp.png";
          this.$store.dispatch("saveOfflineDrawUiRel", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.setDrawBigger(this.row);
              this.$forceUpdate();
              // this.resetForm();
              // this.dialogVisibleBigger = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    async groupListMe() {
      const { code, result } = await this.$store.dispatch("queryPrizeName", {
        ruleId: this.row.id
      });

      this.groupArr = [];
      if (code === "0") {
        result.forEach(v => {
          this.groupArr.push({
            value: v,
            id: v
          });
        });
      }
    },
    querySearchAsync(queryString, cb) {
      let restaurants = this.groupArr;
      let results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      cb(results);
    },
    handleSelect(item) {
      console.log("item: ", item);
    },
    switchTab() {
      this.searchConditionDetails.queryType = "memberMobile";
      this.queryDetailList();
    },
    async queryDrawGearList() {
      const { result } = await this.$store.dispatch("queryDrawGearList", {
        id: this.row.id
      });
      this.drawGearList = result.sort();
    },
    selectQueryType(queryType) {
      if (queryType === "memberMobile") {
        this.placeholder = "请输入手机号";
      } else if (queryType === "memberName") {
        this.placeholder = "请输入会员名称";
      } else if (queryType === "订单号") {
        this.placeholder = "请输入订单号";
      }
    },
    async orderDetail(row) {
      if (this.row.orderSource === "online") {
        this.orderId = row.orderId;
        this.dialogOrderDetails = true;
      } else {
        const { result } = await this.$store.dispatch(
          "queryOfflineOrderDetails",
          {
            orderId: row.orderSn,
            orderOfflineId: row.orderId
          }
        );

        this.orderDetailList = result.orderDetail;
        this.dialogVisibleOffline = true;
      }
    },
    detail(row, type) {
      this.$router.push({
        name: "AddSweepstakes",
        query: {
          type: type,
          id: row.id
        }
      });
    },
    del(row) {
      this.$confirm(" 是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        row.operationType = "del";
        this.$store.dispatch("editStoreOfflineDrawRule", row).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    async setDrawBigger(row) {
      this.row = row;
      const { result } = await this.$store.dispatch("queryOfflineDrawUiRel", {
        ruleId: row.id
      });

      if (result) {
        for (let key in this.ruleForm) {
          this.ruleForm[key] = result[key];
        }
        this.showView = true;
        this.ruleForm.id = result.id;
      }
      this.dialogVisibleBigger = true;
    },
    async water(row) {
      this.row = row;
      this.dialogVisible = true;
      // this.queryDrawGearList();
      this.groupListMe();
      this.searchConditionDetails.timeStatus = "alla";
      this.queryDetailList();
    },
    edit(row) {},
    async operation(row) {
      this.row = row;
      const params = JSON.parse(JSON.stringify(row));
      params.enabledState = params.enabledState === "no" ? "yes" : "no";
      const { code } = await this.$store.dispatch("onlineOrOffline", params);
      if (code === "0") {
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        row.enabledState = row.enabledState === "no" ? "yes" : "no";
      }
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;

        this.queryAllDetailList()
          .then(res => {
            let list = res;
            list.forEach(v => {
              // if (v.usedState === "overdue") {
              //   v.usedState = "已过期";
              // } else if (v.usedState === "notUsed") {
              //   v.usedState = "待使用";
              // } else if (v.usedState === "used") {
              //   v.usedState = "已核销";
              // }
              v.drawType = v.drawType === "hexiao" ? "线上核销" : "线上抽奖";
              v.memberInfo = v.memberName + "/" + v.memberMobile;
              v.orderSn = v.receiptSns;
              // if (this.searchConditionDetails.timeStatus === "alla") {
              //   v.prizeInfo = v.prizeName + "*" + v.prizeNum;
              // }
            });
            let tHeader = this.$refs.tixian.columns
              .map(o => o.label !== "序号" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.tixian.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }

            let title =
              this.searchConditionDetails.timeStatus === "alla"
                ? "抽奖流水"
                : "兑换记录";

            let data = this.formatJson(filterVal, list);

            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    searchDetail() {
      this.currentPageDetail = 1;
      this.queryDetailList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingDetail(page) {
      this.currentPageDetail = page;
      this.queryDetailList();
    },
    handleSizeChangeDetail(size) {
      this.currentPageDetail = 1;
      this.pageSizeDetail = size;
      this.queryDetailList();
    },
    async queryAllDetailList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        ruleId: this.row.id
      };
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionDetails)
      );
      searchCondition.tradeTimeStart =
        this.searchConditionDetails.applyDate &&
        this.searchConditionDetails.applyDate.length > 0
          ? this.searchConditionDetails.applyDate[0]
          : "";
      searchCondition.tradeTimeEnd =
        this.searchConditionDetails.applyDate &&
        this.searchConditionDetails.applyDate.length > 0
          ? this.searchConditionDetails.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      let name =
        this.searchConditionDetails.timeStatus === "alla"
          ? "drawAllDetailsList"
          : "exchangeAllRecordList";
      const { result } = await this.$store.dispatch(name, params);

      return result.records;
    },
    async queryDetailList() {
      let params = {
        pageNo: this.currentPageDetail,
        pageSize: this.pageSizeDetail,
        ruleId: this.row.id
      };
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionDetails)
      );
      searchCondition.verifyTimeStart =
        this.searchConditionDetails.applyDate &&
        this.searchConditionDetails.applyDate.length > 0
          ? this.searchConditionDetails.applyDate[0]
          : "";
      searchCondition.verifyTimeEnd =
        this.searchConditionDetails.applyDate &&
        this.searchConditionDetails.applyDate.length > 0
          ? this.searchConditionDetails.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      let name =
        this.searchConditionDetails.timeStatus === "alla"
          ? "drawDetailsList"
          : "exchangeRecordList";
      const { result } = await this.$store.dispatch(name, params);
      const { records, total } = result;
      this.detailsList = records;
      this.totalDetail = total;
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.createTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.createTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "storeOfflineDrawRuleList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    add() {
      this.$router.push({
        name: "AddSweepstakes",
        query: {
          type: "add"
        }
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}

.priview {
  position: relative;
  width: 150px;
  height: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.btn {
  border: 1px solid #ddd;
  text-align: center;
  padding: 10px;
  width: 80px;
  height: 80px;
  cursor: pointer;
  .add-wrapper {
    width: 30px;
    height: 30px;
    line-height: 30px;
    background: #e50065;
    color: #fff;
    text-align: center;
    border-radius: 50%;
    margin: 0 auto;
    span {
      font-size: 12px;
    }
    cursor: pointer;
    .hmicon {
      font-size: 14px;
      margin-right: 0 !important;
    }
  }
}

.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 130px;
    height: 130px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
</style>
